import { RESOURCE_TILE_HEIGHT } from '../content/infinite-content/infinite-content.enums';
import { getDesktopOffsetElements } from './getDesktopOffsetElements';

export const getOffsetElements = (isMobileDevice: boolean, clientHeight: number): number => {
  if (isMobileDevice) {
    return Math.round(clientHeight / RESOURCE_TILE_HEIGHT);
  }

  return getDesktopOffsetElements();
};
